<template>
  <div class="body">
    <div
      style="position:absolute;top:25px;left:60px;width:350px;height:60px;display:flex"
    >
      <img
        src="../../../../static/image/screen/bg2.png"
        alt=""
        style="width:280px;height:92px;position:relative;"
      />
      <div
        style="position:absolute;top: 30px;color: #00A2FD;font-size: 20px;left: 25px;"
      >
        SN号：{{ bmsInfo.sn }}
      </div>
    </div>
    <div class="head">
      <div style="width:1087px;height:113px;">
        <img
          src="../../../../static/image/screen/title2.png"
          alt=""
          style="width:100%;height:100%;position:relative;"
        />
      </div>

      <div style="position:absolute;top: 25px;display:flex;">
        <div>
          <img :src="imgLogo" alt="" style="height: 60px;" />
        </div>
        <span
          style="font-family: FZZYJW--GB1-0;font-size: 50px;color: #ffffff;margin-top: -5px;"
          >KOPA金邦云平台</span
        >
      </div>
    </div>
    <div
      style="position:absolute;top:25px;right:40px;width:350px;height:60px;display:flex"
    >
      <img
        src="../../../../static/image/screen/bg2.png"
        alt=""
        style="width:280px;height:92px;position:relative;"
      />
      <img
        src="../../../../static/image/screen/bank.png"
        alt=""
        style="width:119px;height:92px;margin-left:-25px;cursor:pointer"
        @click="handleClose"
      />
      <div
        style="position:absolute;top: 30px;color: #00A2FD;font-size: 20px;left: 34px;"
      >
        {{ nowTime }}
      </div>
    </div>

    <div class="bms-monitor-container">
      <!-- 状态卡片区域 -->
      <div class="status-bar">
        <el-card class="status-card">
          <h3>总电压</h3>
          <div class="value">
            {{ bmsInfo.voltage }}<span class="unit">V</span>
          </div>
        </el-card>

        <el-card class="status-card">
          <h3>总电流</h3>
          <div class="value">
            {{ bmsInfo.current }}<span class="unit">A</span>
          </div>
        </el-card>

        <el-card class="status-card">
          <h3>SOC</h3>
          <div class="value success">
            {{ bmsInfo.soc }}<span class="unit">%</span>
          </div>
          <!-- <div class="gauge">
            <div class="gauge-fill" style="width: 85%"></div>
          </div> -->
        </el-card>

        <el-card class="status-card">
          <h3>SOH</h3>
          <div class="value">{{ bmsInfo.soh }}<span class="unit">%</span></div>
          <!-- <div class="gauge">
            <div class="gauge-fill" style="width: 92%"></div>
          </div> -->
        </el-card>

        <el-card class="status-card">
          <h3>系统状态</h3>
          <div class="value success">{{ bmsInfo.state }}</div>
        </el-card>
      </div>

      <!-- 继电器状态 -->
      <div class="relay-status">
        <el-card
          class="relay-item"
          v-for="relay in bmsInfo.relays"
          :key="relay.key"
        >
          <h3>{{ relay.name }}</h3>
          <div
            class="relay-state"
            :class="relay.value === '闭合' ? 'relay-on' : 'relay-off'"
          >
            {{ relay.value }}
          </div>
        </el-card>
      </div>

      <!-- 设备位置 -->
      <el-card class="map-container">
        <div class="map-header">
          <h2>设备位置</h2>
          <div style="font-size: large;" v-if="deviceAddress">
            {{ deviceAddress }}
          </div>
        </div>
        <div id="map" class="map-wrapper"></div>
      </el-card>

      <!-- 仪表盘区域 -->
      <div class="dashboard">
        <!-- 基本信息 -->
        <el-card class="card">
          <div class="card-header">
            <h2>基本信息</h2>
          </div>
          <div class="card-body">
            <div class="data-item">
              <h4>循环次数</h4>
              <p>{{ bmsInfo.circle }}</p>
            </div>
            <div class="data-item">
              <h4>绝缘电阻</h4>
              <p>{{ bmsInfo.insResist }}<span class="unit">KΩ</span></p>
            </div>
            <div class="data-item">
              <h4>充放电状态</h4>
              <p class="success">{{ bmsInfo.state }}</p>
            </div>
            <div class="data-item">
              <h4>剩余容量</h4>
              <p>{{ bmsInfo.remCap }}<span class="unit">Ah</span></p>
            </div>
          </div>
        </el-card>

        <!-- 充电信息 -->
        <el-card class="card">
          <div class="card-header">
            <h2>充电信息</h2>
          </div>
          <div class="card-body">
            <div class="data-item">
              <h4>充电请求电流</h4>
              <p>{{ bmsInfo.reqCurr }}<span class="unit">A</span></p>
            </div>
            <div class="data-item">
              <h4>充电请求电压</h4>
              <p>{{ bmsInfo.reqVolt }}<span class="unit">V</span></p>
            </div>
            <div class="data-item">
              <h4>CC1阻值</h4>
              <p>{{ bmsInfo.cc1 }}<span class="unit">Ω</span></p>
            </div>
            <div class="data-item">
              <h4>CC2阻值</h4>
              <p>{{ bmsInfo.cc2 }}<span class="unit">Ω</span></p>
            </div>
          </div>
        </el-card>
        <!-- 故障信息 -->
        <el-card class="card fault-card">
          <div class="card-header">
            <h2>故障信息</h2>
          </div>
          <div class="card-body">
            <div class="data-item">
              <h4>最高故障等级</h4>
              <p class="warning">{{ bmsInfo.maxFaultLevel }}</p>
            </div>
            <div class="data-item">
              <h4>故障数目</h4>
              <p>{{ bmsInfo.faultNums }}</p>
            </div>
            <div class="data-item full-width">
              <h4>故障码</h4>
              <p>{{ bmsInfo.faultCode }}</p>
            </div>
          </div>
        </el-card>
        <!-- 单体电压 -->
        <el-card class="card">
          <div class="card-header">
            <h2>单体电压</h2>
          </div>
          <div class="card-body">
            <div class="data-item">
              <h4>最高单体电压</h4>
              <p>{{ bmsInfo.maxCellVolt }}<span class="unit">mv</span></p>
            </div>
            <div class="data-item">
              <h4>最低单体电压</h4>
              <p>{{ bmsInfo.minCellVolt }}<span class="unit">mv</span></p>
            </div>
            <div class="data-item">
              <h4>最高电压位置</h4>
              <p>{{ bmsInfo.maxCellPos }}</p>
            </div>
            <div class="data-item">
              <h4>最低电压位置</h4>
              <p>{{ bmsInfo.minCellPos }}</p>
            </div>
            <div class="data-item">
              <h4>平均单体电压</h4>
              <p>{{ bmsInfo.avgCellVolt }}<span class="unit">mv</span></p>
            </div>
            <div class="data-item">
              <h4>单体压差</h4>
              <p>{{ bmsInfo.diffCellVolt }}<span class="unit">mv</span></p>
            </div>
          </div>
        </el-card>

        <!-- 温度信息 -->
        <el-card class="card">
          <div class="card-header">
            <h2>温度信息</h2>
          </div>
          <div class="card-body">
            <div class="data-item">
              <h4>最高温度</h4>
              <p>{{ bmsInfo.maxTemp }}<span class="unit">°C</span></p>
            </div>
            <div class="data-item">
              <h4>最低温度</h4>
              <p>{{ bmsInfo.minTemp }}<span class="unit">°C</span></p>
            </div>
            <div class="data-item">
              <h4>最高温度位置</h4>
              <p>{{ bmsInfo.maxTempPos }}</p>
            </div>
            <div class="data-item">
              <h4>最低温度位置</h4>
              <p>{{ bmsInfo.minTempPos }}</p>
            </div>
            <div class="data-item">
              <h4>平均温度</h4>
              <p>{{ bmsInfo.avgTemp }}<span class="unit">°C</span></p>
            </div>
            <div class="data-item">
              <h4>温差</h4>
              <p>{{ bmsInfo.diffTemp }}<span class="unit">°C</span></p>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 图表区域 -->

      <el-card class="chart-container">
        <div class="chart-header">
          <h2>单体电压监测（mv）</h2>
        </div>
        <div class="chart-wrapper">
          <div ref="cellVoltageChart" style="width: 100%; height: 300px;"></div>
        </div>
      </el-card>

      <el-card class="chart-container">
        <div class="chart-header">
          <h2>温度传感器监测（℃）</h2>
        </div>
        <div class="chart-wrapper">
          <div ref="temperatureChart" style="width: 100%; height: 300px;"></div>
        </div>
      </el-card>

      <el-card class="chart-container">
        <div class="chart-header">
          <h2>外总压监测（V）</h2>
        </div>
        <div class="chart-wrapper">
          <div
            ref="totalVoltageChart"
            style="width: 100%; height: 300px;"
          ></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "BMSMonitor",
  data() {
    return {
      sn: "",
      nowTime: "",
      imgLogo: "",
      myTimer: "",
      bmsInfo: {
        current: null,
        voltage: null,
        soc: null,
        soh: null,
        circle: null,
        insResist: null,
        state: "",
        reqCurr: null,
        reqVolt: null,
        remCap: null,
        cc1: null,
        cc2: null,
        maxFaultLevel: null,
        faultNums: null,
        faultCode: null,
        maxCellVolt: null,
        minCellVolt: null,
        maxCellPos: null,
        minCellPos: null,
        avgCellVolt: null,
        diffCellVolt: null,
        maxTemp: null,
        minTemp: null,
        maxTempPos: null,
        minTempPos: null,
        avgTemp: null,
        diffTemp: null,
        relays: [],
        extVoltChart: {
          xAxis: [],
          yAxis: []
        },
        cellChart: {
          xAxis: [],
          yAxis: []
        },
        tempChart: {
          xAxis: [],
          yAxis: []
        }
      },
      deviceAddress: ""
    };
  },

  methods: {
    handleClose() {
      this.$router.go(-1);
    },

    getLogo() {
      this.$store.dispatch("form/handle", {
        url: "/battery/offline/query",
        data: { companyId: localStorage.getItem("companyId") },
        method: "get2",
        callback: resp => {
          if (resp.title) {
            this.companyTitle = resp.title;
            this.imgLogo = resp.logo;
          }
        }
      });
    },
    getRealData() {
      this.$store.dispatch("form/handle", {
        url: "/battery/dcDevice/realTimeData2",
        data: {
          deviceID: this.$route.query.data
        },
        method: "get2",
        callback: resp => {
          if (resp != null) {
            this.nowTime = resp.createDate;
            this.bmsInfo.sn = resp.deviceSn;
            this.parseReponseData(resp);
          }
        }
      });
    },

    getGps() {
      this.$store.dispatch("form/handle", {
        url: "/battery/dcDevice/realtimeGps",
        data: { deviceID: this.$route.query.data },
        method: "get2",
        callback: resp => {
          if (resp) {
            let latitude = resp.latitude;
            let longitude = resp.longitude;
            // Initialize the map and marker using the GPS coordinates
            AMap.plugin("AMap.Geocoder", () => {
              var geocoder = new AMap.Geocoder({
                city: "全国"
              });

              // Create map (assuming you have a map container with id 'mapContainer')
              let map = new AMap.Map("map", {
                zoom: 13,
                center: [longitude, latitude] // Center map on the GPS coordinates
              });

              // Add marker
              let marker = new AMap.Marker({
                position: new AMap.LngLat(longitude, latitude)
              });
              map.add(marker);
              map.setFitView();

              // Get address information for the coordinates
              geocoder.getAddress([longitude, latitude], (status, result) => {
                if (status === "complete" && result.info === "OK") {
                  this.deviceAddress = result.regeocode.formattedAddress;
                }
              });
            });
          }
        }
      });
    },
    parseReponseData(resp) {
      // 初始化基础数据结构（清空原数据）
      this.bmsInfo = {
        ...this.bmsInfo,
        relays: [],
        extVoltChart: { xAxis: [], yAxis: [] }, // HV_ 相关图表
        cellChart: { xAxis: [], yAxis: [] }, // C开头数字（如C1/C2）图表
        tempChart: { xAxis: [], yAxis: [] } // T开头（如T1/T2）图表
        // 其他bmsInfo属性保留原逻辑（curr/volt/soc等）
      };

      this.bmsInfo.current = resp.current;
      this.bmsInfo.voltage = resp.voltage;
      this.bmsInfo.soc = resp.soc;
      this.bmsInfo.soh = resp.soh;
      this.bmsInfo.circle = resp.circle;
      this.bmsInfo.insResist = resp.insResist;
      this.bmsInfo.state =
        ["未知模式", "正在充电", "充电故障", "充电完成"][resp.state] ||
        "未知模式";
      this.bmsInfo.reqCurr = resp.reqCurr;
      this.bmsInfo.reqVolt = resp.reqVolt;
      this.bmsInfo.remCap = resp.remCap;
      this.bmsInfo.cc1 = resp.cc1;
      this.bmsInfo.cc2 = resp.cc2;
      this.bmsInfo.maxFaultLevel = resp.maxFaultLevel;
      this.bmsInfo.faultNums = resp.faultNums;
      this.bmsInfo.faultCode = resp.faultCode;
      this.bmsInfo.maxCellVolt = resp.maxCellVolt;
      this.bmsInfo.minCellVolt = resp.minCellVolt;
      this.bmsInfo.maxCellPos = resp.maxCellPos;
      this.bmsInfo.minCellPos = resp.minCellPos;
      this.bmsInfo.avgCellVolt = resp.avgCellVolt;
      this.bmsInfo.diffCellVolt = resp.diffCellVolt;
      this.bmsInfo.maxTemp = resp.maxTemp;
      this.bmsInfo.minTemp = resp.minTemp;
      this.bmsInfo.maxTempPos = resp.maxTempPos;
      this.bmsInfo.minTempPos = resp.minTempPos;
      this.bmsInfo.avgTemp = resp.avgTemp;
      this.bmsInfo.diffTemp = resp.diffTemp;

      this.bmsInfo.relays = resp.relays.map((status, index) => ({
        key: `relay-${index + 1}`, // 唯一标识
        name: `${index + 1}号继电器`, // 自动生成名称
        value: status ? "闭合" : "断开" // 状态文字
      }));

      this.bmsInfo.extVoltChart = {
        xAxis: resp.extVolts.map((value, index) => `HV_${index + 1}`),
        yAxis: resp.extVolts
      };

      this.bmsInfo.tempChart = {
        xAxis: resp.temps.map((value, index) => `T${index + 1}`),
        yAxis: resp.temps
      };

      this.bmsInfo.cellChart = {
        xAxis: resp.cells.map((value, index) => `C${index + 1}`),
        yAxis: resp.cells
      };

      // ===== 4. 图表更新逻辑（保持不变）=====
      // if (
      //   this.bmsInfo.extVoltChart.xAxis.length === 0 ||
      //   this.bmsInfo.cellChart.xAxis.length === 0 ||
      //   this.bmsInfo.tempChart.xAxis.length === 0
      // ) {
      //   console.warn("部分图表数据为空，跳过更新");
      //   return;
      // }
      this.$nextTick(() => {
        try {
          this.updateCharts();
        } catch (e) {
          console.error("图表更新失败:", e);
          this.initCharts();
        }
      });
    },

    updateCharts() {
      try {
        if (
          !this.totalVoltageChart ||
          !this.cellVoltageChart ||
          !this.temperatureChart
        ) {
          this.initCharts();
          return;
        }

        // 更新单体电压图表（折线图）
        this.cellVoltageChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" }
          },
          xAxis: {
            type: "category",
            data: this.bmsInfo.cellChart.xAxis || []
          },
          yAxis: {
            type: "value",
            min: function(value) {
              return Math.floor(value.min * 0.9);
            },
            max: function(value) {
              return Math.ceil(value.max * 1.1);
            },
            axisLabel: { formatter: "{value}" }
          },
          animation: true,
          animationDuration: 500,
          series: [
            {
              name: "电压",
              type: "bar",
              data: this.bmsInfo.cellChart.yAxis || [],
              itemStyle: {
                color: "#4bc0c0",
                borderRadius: [4, 4, 0, 0]
              },
              barWidth: "60%",
              // 添加label配置以显示数值
              label: {
                show: true, // 显示标签
                position: "top", // 标签位置（top/insideTop/inside等）
                formatter: "{c}", // 显示内容，{c}表示数据值
                color: "#4bc0c0", // 文字颜色
                fontSize: 12 // 文字大小
              },
              emphasis: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#4bc0c0" },
                      { offset: 1, color: "#2a7f7f" }
                    ]
                  }
                },
                // 高亮时也显示标签
                label: {
                  show: true
                }
              }
            }
          ]
        });

        // 更新温度图表（柱状图）
        this.temperatureChart.setOption({
          tooltip: {
            // 必须配置tooltip
            trigger: "axis",
            axisPointer: { type: "shadow" }
          },
          xAxis: {
            type: "category",
            data: this.bmsInfo.tempChart.xAxis || []
          },
          yAxis: {
            type: "value",
            axisLabel: { formatter: "{value}" }
          },
          series: [
            {
              name: "温度",
              type: "bar",
              data: this.bmsInfo.tempChart.yAxis || [],
              itemStyle: { color: "#ff6384" },
              // 确保数据格式正确
              label: {
                show: true,
                position: "top",
                formatter: "{c}"
              }
            }
          ]
        }); // 更新总电压图表（柱状图）
        this.totalVoltageChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" }
          },
          xAxis: {
            type: "category",
            data: this.bmsInfo.extVoltChart.xAxis
          },
          yAxis: {
            type: "value",
            min: function(value) {
              return Math.floor(value.min * 0.9);
            },
            max: function(value) {
              return Math.ceil(value.max * 1.1);
            },
            axisLabel: { formatter: "{value}" }
          },
          series: [
            {
              name: "电压",
              type: "bar",
              data: this.bmsInfo.extVoltChart.yAxis || [],
              itemStyle: { color: "#36a2eb" },
              label: { show: true, position: "top", formatter: "{c}" }
            }
          ]
        });
      } catch (e) {
        console.error("图表更新错误:", e);
        // 出错时重新初始化图表
        this.initCharts();
      }
    },

    initCharts() {
      try {
        // 确保DOM元素存在
        if (
          !this.$refs.totalVoltageChart ||
          !this.$refs.cellVoltageChart ||
          !this.$refs.temperatureChart
        ) {
          console.warn("图表容器未找到");
          return;
        }

        // 确保数据存在
        if (
          !this.bmsInfo.extVoltChart ||
          !this.bmsInfo.cellChart ||
          !this.bmsInfo.tempChart
        ) {
          console.warn("图表数据未初始化");
          return;
        }

        // 初始化总压图表

        this.cellVoltageChart = this.$echarts.init(this.$refs.cellVoltageChart);
        this.cellVoltageChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" }
          },
          xAxis: {
            type: "category",
            data: this.bmsInfo.cellChart.xAxis || []
          },
          yAxis: {
            type: "value",
            min: function(value) {
              return Math.floor(value.min * 0.9);
            },
            max: function(value) {
              return Math.ceil(value.max * 1.1);
            },
            axisLabel: { formatter: "{value}" }
          },
          series: [
            {
              name: "电压",
              type: "bar", // Changed from "line" to "bar"
              data: this.bmsInfo.cellChart.yAxis || [],
              itemStyle: {
                color: "#4bc0c0",
                borderRadius: [4, 4, 0, 0] // Optional: adds rounded corners to bars
              },

              barWidth: "60%",
              emphasis: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#4bc0c0" },
                      { offset: 1, color: "#2a7f7f" }
                    ]
                  }
                }
              }
            }
          ]
        });

        // 初始化温度图表
        this.temperatureChart = this.$echarts.init(this.$refs.temperatureChart);
        this.temperatureChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" }
          },
          xAxis: {
            type: "category",
            data: this.bmsInfo.tempChart.xAxis || []
          },
          yAxis: {
            type: "value",
            min: function(value) {
              // 动态计算最小值（如向下取整或留出间距）
              return Math.floor(value.min * 0.9); // 示例：最小值减少10%空间
            },
            max: function(value) {
              // 动态计算最大值（如向上取整）
              return Math.ceil(value.max * 1.1); // 示例：最大值增加10%空间
            },
            axisLabel: { formatter: "{value}" }
          },
          series: [
            {
              name: "温度",
              type: "bar",
              data: this.bmsInfo.tempChart.yAxis || [],
              itemStyle: { color: "#ff6384" },
              label: { show: true, position: "top", formatter: "{c}" }
            }
          ]
        });
        this.totalVoltageChart = this.$echarts.init(
          this.$refs.totalVoltageChart
        );
        this.totalVoltageChart.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" }
          },
          xAxis: {
            type: "category",
            data: this.bmsInfo.extVoltChart.xAxis || []
          },
          yAxis: {
            type: "value",
            min: function(value) {
              // 动态计算最小值（如向下取整或留出间距）
              return Math.floor(value.min * 0.9); // 示例：最小值减少10%空间
            },
            max: function(value) {
              // 动态计算最大值（如向上取整）
              return Math.ceil(value.max * 1.1); // 示例：最大值增加10%空间
            },
            axisLabel: { formatter: "{value}" }
          },
          series: [
            {
              name: "电压",
              type: "bar",
              data: this.bmsInfo.extVoltChart.yAxis || [],
              itemStyle: { color: "#36a2eb" },
              label: { show: true, position: "top", formatter: "{c}" }
            }
          ]
        });
        // 响应式调整图表大小
        window.addEventListener("resize", this.handleResize);
      } catch (e) {
        console.error("图表初始化错误:", e);
      }
    },
    handleResize() {
      if (this.totalVoltageChart) {
        this.totalVoltageChart.resize();
      }
      if (this.cellVoltageChart) {
        this.cellVoltageChart.resize();
      }
      if (this.temperatureChart) {
        this.temperatureChart.resize();
      }
    }
  },
  beforeMount() {
    this.getLogo();
    this.getGps();
    this.getRealData();
  },
  mounted() {
    this.myTimer = setInterval(() => {
      console.log("定时2秒请求");
      this.getRealData();
    }, 1000 * 5); //5秒定时访问
    this.initCharts();
  },
  beforeDestroy() {
    if (this.totalVoltageChart) {
      this.totalVoltageChart.dispose();
    }
    if (this.cellVoltageChart) {
      this.cellVoltageChart.dispose();
    }
    if (this.temperatureChart) {
      this.temperatureChart.dispose();
    }
  },
  destroyed() {
    clearInterval(this.myTimer);
  } //生命周期 - 销毁完成
};
</script>

<style lang="less">
@primary-color: #3498db;
@secondary-color: #2ecc71;
@danger-color: #e74c3c;
@warning-color: #f39c12;
@dark-color: #34495e;
@light-color: #ecf0f1;
@card-bg: #ffffff;
@body-bg: #f5f7fa;
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.body {
  padding: 0px;
  margin: 0px;
  color: #222;
  font-family: "微软雅黑";
}
.body {
  font-family: "Roboto", sans-serif;
  background-color: var(--body-bg);
  /* 添加背景图片 */
  background-image: url("../../../../static/image/screen/bg.png"); /* 替换为你的图片URL */
  background-size: cover; /* 覆盖整个页面 */
  background-position: center; /* 居中显示 */
  background-attachment: fixed; /* 固定背景不滚动 */
  background-blend-mode: overlay; /* 混合模式，可选 */
}

.head {
  height: 138px;
  display: flex;
  justify-content: center;
  background-size: 100% 100%;
  position: relative;
}

.time {
  width: 244px;
  height: 57px;
  position: absolute;
  right: 70px;
  top: 0;
  line-height: 76px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  padding-right: 10px;
  font-family: electronicFont;
}
.bms-monitor-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Roboto", "PingFang SC", "Microsoft YaHei", sans-serif;
  // background-color: @body-bg;
  color: #333;
  line-height: 1.6;

  .header {
    text-align: center;
    margin-bottom: 30px;
    padding: 20px 0;
    background: linear-gradient(135deg, @primary-color, @secondary-color);
    color: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;

    h1 {
      font-size: 2.2rem;
      margin-bottom: 10px;
    }

    .device-info {
      position: absolute;
      top: 10px;
      left: 20px;
      font-size: 0.9rem;
      background-color: rgba(255, 255, 255, 0.2);
      padding: 5px 10px;
      border-radius: 20px;
    }
  }

  .status-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .status-card {
      flex: 1;
      margin: 0 10px;
      // padding: 15px;
      background-color: @card-bg;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      text-align: center;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      h3 {
        font-size: 1rem;
        color: #7f8c8d;
        margin-bottom: 10px;
      }

      .value {
        font-size: 1.8rem;
        font-weight: 500;

        &.success {
          color: @secondary-color;
        }

        &.warning {
          color: @warning-color;
        }

        &.danger {
          color: @danger-color;
        }
      }

      .unit {
        font-size: 1rem;
        color: #7f8c8d;
      }

      .gauge {
        height: 10px;
        background-color: #eee;
        border-radius: 5px;
        margin-top: 5px;
        overflow: hidden;

        .gauge-fill {
          height: 100%;
          background: linear-gradient(90deg, @secondary-color, @primary-color);
          border-radius: 5px;
        }
      }
    }
  }

  .relay-status {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 30px;
    margin-bottom: 30px;

    .relay-item {
      padding: 15px;
      min-width: 140px;
      background-color: @card-bg;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      text-align: center;
      h3 {
        font-size: 1rem;
        color: #7f8c8d;
        margin-bottom: 10px;
      }

      .relay-state {
        font-size: 1.2rem;
        font-weight: 500;
        padding: 5px 10px;
        border-radius: 20px;
        display: inline-block;

        &.relay-on {
          background-color: @secondary-color;
          color: white;
        }

        &.relay-off {
          background-color: #eee;
          color: #7f8c8d;
        }
      }
    }
  }

  .map-container {
    margin-bottom: 20px;

    .map-header {
      display: flex;
      gap: 20px;
      align-items: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      h2 {
        font-size: 1.2rem;
        color: @dark-color;
      }
    }

    .map-wrapper {
      position: relative;
      height: 300px;
      width: 100%;
      background-color: #f0f0f0;
      border-radius: 4px;
      overflow: hidden;

      .map-placeholder {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #7f8c8d;

        i {
          font-size: 3rem;
          margin-bottom: 15px;
        }
      }
    }
  }

  .dashboard {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 30px;

    .card {
      background-color: @card-bg;
      border-radius: 8px;
      // padding: 20px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      &.fault-card {
        background-color: #fff8f8;
        border-left: 4px solid @danger-color;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-bottom: 15px;
        // padding-bottom: 10px;
        border-bottom: 1px solid #eee;

        h2 {
          font-size: 1.2rem;
          color: @dark-color;
        }
      }

      .card-body {
        display: grid;
        grid-template-columns: 1fr 1fr;
        // gap: 15px;

        .data-item {
          margin-bottom: 10px;

          h4 {
            font-size: 0.9rem;
            color: #7f8c8d;
            margin-bottom: 5px;
          }

          p {
            font-size: 1.2rem;
            font-weight: 500;
          }

          &.full-width {
            grid-column: 1 / -1;
          }
        }

        .fault-list {
          list-style: none;

          li {
            padding: 8px 0;
            border-bottom: 1px solid #eee;

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }

  .chart-container {
    background-color: @card-bg;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .chart-header {
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      h2 {
        font-size: 1.2rem;
        color: @dark-color;
      }
    }

    .chart-wrapper {
      position: relative;
      height: 300px;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .status-bar {
      flex-direction: column;

      .status-card {
        margin: 10px 0;
      }
    }

    .dashboard {
      grid-template-columns: 1fr;
    }

    .relay-item {
      min-width: 100%;
    }

    .device-info {
      position: static;
      margin-bottom: 10px;
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/realData.vue